export default __webpack_public_path__ + "static/media/add-favourite-black.b9d4fa1f.svg";